module.exports = __webpack_public_path__ + "static/img/051_TO8_1585_og.8f6ee63.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/051_TO8_1585_og.jpg
// module id = 7CiI
// module chunks = 0